<template>
  <div id="Structure" class="q-pa-md">
    <div class="text-h6 q-mx-md q-my-sm">{{ name }}</div>
    <div class="row">
      <div class="col-2 q-ma-sm" v-if="structure">
        <q-list class="buttons-list">
          <q-item
            v-for="item in structures"
            :key="item"
            clickable
            v-ripple
            :active="structure === item"
            @click="changeStructureSelect(item)"
            active-class="itemSelect"
            class="item q-pa-md q-ma-sm shadow-1"
          >
            <q-item-section class="ellipsis">
              {{ $gettext(item.name) }}</q-item-section
            >
          </q-item>
        </q-list>
      </div>
      <q-card class="col-9 q-ma-md no-padding">
        <q-card-section class="padding-crud">
          <component
            :is="structure.component"
            :ref="'crudLayoutSearch-' + structure.name"
            :key="structure.interface"
            :name="$gettext(structure.name)"
            :interface="structure.interface"
            :id="id"
            :page="structure.page"
            :page-table="structure.pageTable"
            :page-detail="structure.pageDetail"
            :page-search="structure.pageSearch"
            :controller-search="structure.controllerSearch"
            clean-layout
          />
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
import CompanyTablePage from './../company/CompanyTablePage'
import CompanyPage from './../company/CompanyPage'
import CompanyDetailPage from './../company/CompanyDetailPage'
import CompanySearchPage from './../company/CompanySearchPage'
import LandfillPage from './../landfill/LandfillPage'
import LandfillDetailPage from './../landfill/LandfillDetailPage'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'Structure',
  components: {
    CrudLayoutSearch,
    CompanyPage,
    CompanyTablePage,
    CompanyDetailPage,
    CompanySearchPage,
    LandfillPage
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Structure extends Vue {
  structures = [];
  structure = '';
  indice = 0;

  beforeMount () {
    this.structures = [
      {
        component: CrudLayoutSearch,
        name: 'COMPANY',
        interface: 'company.pesquisar',
        page: CompanyPage,
        pageTable: CompanyTablePage,
        pageDetail: CompanyDetailPage,
        pageSearch: CompanySearchPage,
        controllerSearch: false
      },

      {
        component: CrudLayoutSearch,
        name: 'LANDFILL',
        interface: 'landfill.pesquisar',
        page: LandfillPage,
        pageTable: null,
        pageDetail: LandfillDetailPage,
        pageSearch: null,
        controllerSearch: false
      }
    ]
    this.structure = this.structures[0]
  }

  changeStructureSelect (item) {
    this.structure = item
  }
}
export default Structure
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

#Structure {
 .dataTableCrud {
     height: calc(65vh - 25px);
     box-shadow: none!important;
     padding: 0px 10px;
   }
   ::v-deep {
    .jt-crud-container {
      padding: 0%;
    }
  }

   .buttons-top-crud{
    margin-top: 5px;
    margin-bottom: -3px;
  }

.padding-crud{
     padding: 0px 10px 10px;
     margin-top: -15px;
   }

    .itemSelect{
     color: white;
     background: $secondary!important;
     border-left: 5px solid $dark!important;
     padding-left: 5%!imporant;
   }

   .item{
     background: white;
     font-weight: 500;
     padding-left: 10%;
     font-size: 1rem;
   }
 }
</style>
